<template>
  <form name="form" @submit.prevent="register">
    <u-input type="text" class="form-control" placeholder="请输入用户名" v-model="username" autofocus tabindex="1">
      <span v-if="validation.hasError('username')" slot="right" class="input-error">{{validation.firstError('username')}}</span>
    </u-input>
    <u-input type="password" class="form-control" placeholder="请输入密码" v-model="password" tabindex="2">
      <span v-if="validation.hasError('password')" slot="right" class="input-error">{{validation.firstError('password')}}</span>
    </u-input>
    <u-input type="password" class="form-control" placeholder="再次输入密码" v-model="repeat" tabindex="3">
      <span v-if="validation.hasError('repeat')" slot="right" class="input-error">{{validation.firstError('repeat')}}</span>
    </u-input>
    <u-button native-type="submit" style="margin-top: 40px">注册</u-button>
  </form>
</template>
<script>
import { mapActions } from 'vuex'
import { Validator } from 'simple-vue-validator'
import AV from 'leancloud-storage'
export default {
  data () {
    return {
      username: '',
      password: '',
      repeat: '',
      submitted: false
    }
  },
  validators: {
    username: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('用户名必填').minLength(6, '至少6位以上的用户名')
      }
    },
    password: {
      debounce: 300,
      validator (v) {
        return Validator.value(v).required('密码必填').minLength(6, '至少6位以上的密码')
      }
    },
    'repeat, password': {
      debounce: 300,
      validator (repeat, password) {
        if (this.submitted || this.validation.isTouched('repeat')) {
          return Validator.value(repeat).required('请再次输入密码').match(password, '两次密码不一致')
        }
      }
    }
  },
  methods: {
    ...mapActions(['updateUserFromAV']),
    register () {
      this.submitted = true
      this.$validate().then(isSuccess => {
        if (isSuccess) {
          const user = new AV.User()
          user.setUsername(this.username)
          user.setPassword(this.password)
          user.signUp().then(loginedUser => {
            this.updateUserFromAV(loginedUser)
            this.$toast('恭喜您注册成功')
            this.$router.push('/')
          }).catch(error => {
            if (error.code === 202) {
              this.$toast('该用户名已被注册')
            }
            console.log(error)
          })
        }
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?e8a60dd2